import { getScheduleRegistrationLinkCode } from "@/api/schedule";

export const getScheduleRegistrationLink = async (scheduleId: string): Promise<string> => {
  const { infoUpdateCode } = await getScheduleRegistrationLinkCode(scheduleId);
  return `${window.location.origin}/ficha-cadastral-agendamento?infoUpdateCode=${encodeURIComponent(infoUpdateCode)}`;
};

export const normalizeWhatsAppPhone = (phone: string): string | null => {
  const digits = phone.replace(/\D/g, "");

  if (digits.length === 10 || digits.length === 11) {
    return `55${digits}`;
  }

  if ((digits.length === 12 || digits.length === 13) && digits.startsWith("55")) {
    return digits;
  }

  return null;
};
